import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import AuthCallback from "@/components/AuthCallback";
import RoleGate from "@/components/RoleGate";
import BillingGate from "@/components/BillingGate";
import TermsGate from "@/components/TermsGate";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PatientApp from "@/pages/PatientApp";
import { Terms, Privacy, RefundPolicy, Disclaimer } from "@/pages/Legal";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FBFBF7]">
        <div className="w-10 h-10 rounded-full border-4 border-[#EBF3FB] border-t-[#1E5AA8] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function RoleRouter() {
  return (
    <RoleGate patientView={<PatientApp />}>
      <BillingGate>
        <Dashboard />
      </BillingGate>
    </RoleGate>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/dashboard" element={<Protected><TermsGate><RoleRouter /></TermsGate></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <I18nProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <AppRouter />
          </BrowserRouter>
        </I18nProvider>
      </AuthProvider>
    </div>
  );
}
